import { IReportingModel } from "@/Report/Models/UI/IReportingModel";

class EmbeddedReportProperties {
    public Model: IReportingModel;
}

class EmbeddedReport extends React.Component<EmbeddedReportProperties, never> {
    public render(): JSX.Element {
        var iframe: JSX.Element = null;

        if (this.props.Model && this.props.Model.get("IsAuthenticated")) {
            var url = this.props.Model.get("MainReportingURL") + "/jwt?jwt=" + this.props.Model.get("JWTToken") + "&return_to=" + this.props.Model.get("MainReportingDashboardURL");
            iframe = <iframe id="sisenseframe" width="100%" style={{ height: "980px" }} src={url} />;
        }

        return (
            <div id="test" className="embeddedReporting">
                {iframe}
            </div>
        );
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public componentWillUnmount(): void {
        let logoutUrl = sessionStore.clientConfiguration.ReportingSisenseMainURL + "/api/auth/logout";
        window.frames["sisenseframe"].src = logoutUrl;
    }
}

export { EmbeddedReport };
